import { languages } from '@/constants/languages';
import { LanguageId } from '@/enums/enums';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line jsdoc/require-jsdoc
const useLanguageHelper = (translation: string) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation(translation);
  const isEnglish: boolean = i18n.language !== 'ar';
  const currentLanguageId = useMemo((): LanguageId => {
    return languages.find((language) => language.code === i18n.language)?.id ?? LanguageId.Arabic;
  }, [i18n.language]);

  return {
    isEnglish,
    t,
    currentLanguageId,
  };
};

export default useLanguageHelper;
